import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormMode } from '@shared/models/form-mode.enum';
import { ConfirmDialogService } from '@sharedComponents/dialogs/confirm-dialog/confirm-dialog.service';
import { TolgeeService } from '@core/translation/tolgee.service';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: false
})
export class PageHeaderComponent {
    @Input() pageTitle: string;
    @Input() formMode: FormMode;
    @Input() skipDialog = false;
    @Output() leaveEvent: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private readonly confirmDialogService: ConfirmDialogService,
        private readonly _tolgee: TolgeeService,
    ) {
    }

    onClickLeaveButton(): void {
        if (this.formMode !== FormMode.VIEW && !this.skipDialog) {
            this.handleCloseDialog(
                this._tolgee.translate('common.unsavedChanges.leavePageBody'),
                this._tolgee.translate('common.unsavedChanges.leavePageConfirmYes'),
            ).openWithCallback(() => {
                this.navigateToOverview();
            });
        } else {
            this.navigateToOverview();
        }
    }

    private handleCloseDialog(text: string, yesButtonText: string): ConfirmDialogService {
        return this.confirmDialogService
            .useWarnTheme()
            .setTitle(this._tolgee.translate('common.confirm.attention'))
            .setBody(text)
            .setYesButton({
                text: yesButtonText
            })
            .setNoButton({
                text: this._tolgee.translate('common.cancel')
            });
    }

    private navigateToOverview(): void {
        this.leaveEvent.emit();
    }
}
